
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../../components/seo/SEOHead';

export default function GalleryPage() {
  const [activeFilter, setActiveFilter] = useState('all');
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const filters = [
    { id: 'all', name: 'All Gallery' },
    { id: 'clinic', name: 'Clinic Interior' },
    { id: 'team', name: 'Our Team' },
    { id: 'services', name: 'Services' },
    { id: 'equipment', name: 'Equipment' }
  ];

  const clinicImages = [
    {
      id: 1,
      src: 'https://static.readdy.ai/image/9921b96583d8c2e46a2d40cbefc3b198/0e4c8c2f96f7c8d68e3c212d95057863.jpeg',
      alt: 'Modern Dental Clinic Interior',
      category: 'clinic',
      title: 'Reception Area'
    },
    {
      id: 33,
      src: 'https://static.readdy.ai/image/9921b96583d8c2e46a2d40cbefc3b198/c96a38cb87fbd59e39d5ed9ce6a20f61.jpeg',
      alt: 'Dental Clinic Reception',
      category: 'clinic',
      title: 'Main Reception Desk'
    },
    {
      id: 34,
      src: 'https://static.readdy.ai/image/9921b96583d8c2e46a2d40cbefc3b198/9cd7e94d6c794ef60e57d2d86419f839.jpeg',
      alt: 'Clinic Waiting Area',
      category: 'clinic',
      title: 'Patient Waiting Area'
    },
    {
      id: 35,
      src: 'https://static.readdy.ai/image/9921b96583d8c2e46a2d40cbefc3b198/95fb777fb577668d3944b3f2d8122e37.jpeg',
      alt: 'Treatment Room',
      category: 'clinic',
      title: 'Modern Treatment Room'
    },
    {
      id: 36,
      src: 'https://readdy.ai/api/search-image?query=Advanced%20dental%20chair%20setup%2C%20modern%20dental%20equipment%2C%20professional%20dental%20operatory%20chair%2C%20high-tech%20dental%20treatment%20station&width=400&height=400&seq=dental-chair&orientation=squarish',
      alt: 'Dental Chair Setup',
      category: 'clinic',
      title: 'Advanced Dental Chair'
    },
    {
      id: 37,
      src: 'https://static.readdy.ai/image/9921b96583d8c2e46a2d40cbefc3b198/2feabb2a0c46f0570ac59b3249d7fe78.jpeg',
      alt: 'Sterilization Area',
      category: 'clinic',
      title: 'Sterilization Center'
    },
    {
      id: 38,
      src: 'https://static.readdy.ai/image/9921b96583d8c2e46a2d40cbefc3b198/a089386ae4c329b047dfdb863bc0d09f.jpeg',
      alt: 'Consultation Room',
      category: 'clinic',
      title: 'Doctor Consultation Room'
    }
  ];

  const equipmentImages = [
    {
      id: 39,
      src: 'https://readdy.ai/api/search-image?query=Digital%20X-ray%20machine%20dental%20equipment%2C%20modern%20dental%20radiography%20equipment%2C%20digital%20dental%20imaging%20system%2C%20advanced%20dental%20X-ray%20technology&width=400&height=400&seq=digital-xray&orientation=squarish',
      alt: 'Digital X-Ray Machine',
      category: 'equipment',
      title: 'Digital X-Ray Equipment'
    },
    {
      id: 40,
      src: 'https://readdy.ai/api/search-image?query=Dental%20microscope%20equipment%2C%20advanced%20dental%20microscopy%2C%20precision%20dental%20microscope%2C%20high-tech%20dental%20magnification%20system&width=400&height=400&seq=dental-microscope&orientation=squarish',
      alt: 'Dental Microscope',
      category: 'equipment',
      title: 'Advanced Dental Microscope'
    },
    {
      id: 41,
      src: 'https://readdy.ai/api/search-image?query=Laser%20dental%20equipment%2C%20dental%20laser%20therapy%20machine%2C%20advanced%20laser%20dentistry%20equipment%2C%20modern%20dental%20laser%20system&width=400&height=400&seq=laser-equipment&orientation=squarish',
      alt: 'Laser Equipment',
      category: 'equipment',
      title: 'Laser Dental Equipment'
    },
    {
      id: 42,
      src: 'https://readdy.ai/api/search-image?query=Digital%20intraoral%20scanner%2C%203D%20dental%20scanner%2C%20modern%20dental%20impression%20scanner%2C%20advanced%20dental%20scanning%20technology&width=400&height=400&seq=intraoral-scanner&orientation=squarish',
      alt: 'Intraoral Scanner',
      category: 'equipment',
      title: 'Digital Intraoral Scanner'
    },
    {
      id: 43,
      src: 'https://readdy.ai/api/search-image?query=Ultrasonic%20dental%20scaler%2C%20dental%20cleaning%20equipment%2C%20professional%20dental%20scaling%20unit%2C%20advanced%20dental%20hygiene%20equipment&width=400&height=400&seq=ultrasonic-scaler&orientation=squarish',
      alt: 'Ultrasonic Scaler',
      category: 'equipment',
      title: 'Ultrasonic Scaling Unit'
    },
    {
      id: 44,
      src: 'https://readdy.ai/api/search-image?query=Autoclave%20sterilization%20system%2C%20dental%20sterilization%20equipment%2C%20medical%20autoclave%20machine%2C%20professional%20sterilization%20unit&width=400&height=400&seq=autoclave&orientation=squarish',
      alt: 'Autoclave Sterilizer',
      category: 'equipment',
      title: 'Autoclave Sterilization System'
    },
    {
      id: 45,
      src: 'https://static.readdy.ai/image/9921b96583d8c2e46a2d40cbefc3b198/770f761f17bbe4e2dbf576c64ee80ecd.jpeg',
      alt: 'Advanced Dental Equipment',
      category: 'equipment',
      title: 'Professional Dental Equipment'
    }
  ];

  const teamImages = [
    {
      id: 2,
      src: 'https://toothdoctor.in/wp-content/uploads/2023/07/tooth-doctor-5-768x779.jpg',
      alt: 'Dr N R Shrinivaasan',
      category: 'team',
      title: 'Dr N R Shrinivaasan',
      subtitle: 'M.D.S., Consultant Orthodontist'
    },
    {
      id: 3,
      src: 'https://toothdoctor.in/wp-content/uploads/elementor/thumbs/sandhiya-q8ywhy4exkvzh53f4jl50qjghrfs6dlutl3rqdr8hy.jpg',
      alt: 'Dr.Sandhya',
      category: 'team',
      title: 'Dr.Sandhya',
      subtitle: 'General and Cosmetic Dentist'
    },
    {
      id: 4,
      src: 'https://toothdoctor.in/wp-content/uploads/2023/07/WhatsApp-Image-2023-07-07-at-11.13.28-AM-768x779.jpeg',
      alt: 'Dr.Shanmugasundaram',
      category: 'team',
      title: 'Dr.Shanmugasundaram',
      subtitle: 'MDS, FIBOMS, MBA'
    },
    {
      id: 5,
      src: 'https://toothdoctor.in/wp-content/uploads/2023/07/tooth-doctor-768x779.jpg',
      alt: 'Dr.K.Dhanadivya',
      category: 'team',
      title: 'Dr.K.Dhanadivya',
      subtitle: 'Consultant Periodontist'
    },
    {
      id: 6,
      src: 'https://toothdoctor.in/wp-content/uploads/2023/07/tooth-doctor-2-768x779.jpg',
      alt: 'Dr.Suthanraj.AK',
      category: 'team',
      title: 'Dr.Suthanraj.AK',
      subtitle: 'MDS (OMFS) Association Professor'
    },
    {
      id: 7,
      src: 'https://toothdoctor.in/wp-content/uploads/2024/09/WhatsApp-Image-2024-09-23-at-7.53.13-PM-150x150.jpeg',
      alt: 'Dr.S.Riyaz Mohammed',
      category: 'team',
      title: 'Dr.S.Riyaz Mohammed',
      subtitle: 'Periodontist & ORAL implantologist'
    },
    {
      id: 8,
      src: 'https://toothdoctor.in/wp-content/uploads/2024/09/WhatsApp-Image-2024-09-23-at-7.53.14-PM-150x150.jpeg',
      alt: 'Dr.S.Sathiyaseelan',
      category: 'team',
      title: 'Dr.S.Sathiyaseelan',
      subtitle: 'MDS., Consultant Prosthodontist'
    },
    {
      id: 9,
      src: 'https://toothdoctor.in/wp-content/uploads/2024/10/WhatsApp-Image-2024-10-07-at-9.35.59-AM-150x150.jpeg',
      alt: 'Dr Santhosh',
      category: 'team',
      title: 'Dr Santhosh',
      subtitle: 'Senior consultant oral and maxillofacial surgeon'
    },
    {
      id: 10,
      src: 'https://toothdoctor.in/wp-content/uploads/2024/10/WhatsApp-Image-2024-10-03-at-3.23.45-PM-150x150.jpeg',
      alt: 'Dr Aysha Mansoor',
      category: 'team',
      title: 'Dr Aysha Mansoor',
      subtitle: 'MDS Pedodontist (child specialist)'
    },
    {
      id: 11,
      src: 'https://toothdoctor.in/wp-content/uploads/2024/10/WhatsApp-Image-2024-10-03-at-3.32.19-PM-150x150.jpeg',
      alt: 'Dr Venkateswaran',
      category: 'team',
      title: 'Dr Venkateswaran',
      subtitle: 'MDH., PHD orthodontics'
    },
    {
      id: 12,
      src: 'https://toothdoctor.in/wp-content/uploads/2024/10/WhatsApp-Image-2024-10-04-at-7.37.48-PM-150x150.jpeg',
      alt: 'Dr. S. Akshai',
      category: 'team',
      title: 'Dr. S. Akshai',
      subtitle: 'MDS specialist in Conservative Dentistry'
    },
    {
      id: 13,
      src: 'https://toothdoctor.in/wp-content/uploads/2024/09/passport-photo-150x150.jpg',
      alt: 'Dr.M.Deepalakshmi',
      category: 'team',
      title: 'Dr.M.Deepalakshmi',
      subtitle: 'Senior consultant, Endodontist'
    },
    {
      id: 14,
      src: 'https://toothdoctor.in/wp-content/uploads/2025/08/WhatsApp-Image-2025-08-16-at-10.42.29-AM-150x150.jpeg',
      alt: 'Dr. M. Mohamed Jubair Hashir',
      category: 'team',
      title: 'Dr. M. Mohamed Jubair Hashir',
      subtitle: 'Endodontist & Root Canal Specialist'
    }
  ];

  const serviceImages = [
    {
      id: 101,
      src: 'https://readdy.ai/api/search-image?query=Indian%20dentist%20performing%20root%20canal%20treatment%20on%20Indian%20patient%2C%20endodontic%20procedure%20in%20modern%20dental%20clinic%2C%20professional%20dental%20care%20in%20India%2C%20sterile%20dental%20environment&width=400&height=300&seq=root-canal-indian&orientation=landscape',
      alt: 'Root Canal Treatment',
      category: 'services',
      title: 'Root Canal Treatment'
    },
    {
      id: 102,
      src: 'https://readdy.ai/api/search-image?query=Indian%20dental%20surgeon%20placing%20dental%20implant%20on%20Indian%20patient%2C%20titanium%20implant%20surgery%20in%20modern%20Indian%20dental%20clinic%2C%20professional%20implant%20dentistry&width=400&height=300&seq=dental-implants-indian&orientation=landscape',
      alt: 'Dental Implants',
      category: 'services',
      title: 'Dental Implants'
    },
    {
      id: 103,
      src: 'https://readdy.ai/api/search-image?query=Indian%20dentist%20applying%20dental%20veneers%20on%20Indian%20patient%2C%20porcelain%20veneer%20procedure%20in%20Chennai%20dental%20clinic%2C%20cosmetic%20dentistry%20treatment&width=400&height=300&seq=dental-veneers-indian&orientation=landscape',
      alt: 'Dental Veneers',
      category: 'services',
      title: 'Dental Veneers'
    },
    {
      id: 104,
      src: 'https://readdy.ai/api/search-image?query=Indian%20orthodontist%20adjusting%20braces%20on%20Indian%20patient%2C%20orthodontic%20treatment%20in%20modern%20dental%20clinic%2C%20teeth%20straightening%20procedure&width=400&height=300&seq=orthodontics-braces-indian&orientation=landscape',
      alt: 'Orthodontics & Braces',
      category: 'services',
      title: 'Orthodontics & Braces'
    },
    {
      id: 105,
      src: 'https://readdy.ai/api/search-image?query=Indian%20dentist%20performing%20teeth%20whitening%20on%20Indian%20patient%2C%20professional%20dental%20bleaching%20treatment%2C%20bright%20smile%20enhancement%20in%20dental%20clinic&width=400&height=300&seq=teeth-whitening-indian&orientation=landscape',
      alt: 'Teeth Whitening',
      category: 'services',
      title: 'Teeth Whitening'
    },
    {
      id: 106,
      src: 'https://readdy.ai/api/search-image?query=Indian%20dentist%20placing%20dental%20crown%20on%20Indian%20patient%2C%20crown%20and%20bridge%20procedure%20in%20modern%20dental%20clinic%2C%20restorative%20dentistry%20treatment&width=400&height=300&seq=crowns-bridges-indian&orientation=landscape',
      alt: 'Crowns & Bridges',
      category: 'services',
      title: 'Crowns & Bridges'
    },
    {
      id: 107,
      src: 'https://readdy.ai/api/search-image?query=Indian%20dentist%20fitting%20complete%20dentures%20on%20elderly%20Indian%20patient%2C%20denture%20placement%20procedure%20in%20dental%20clinic%2C%20prosthetic%20dentistry&width=400&height=300&seq=complete-dentures-indian&orientation=landscape',
      alt: 'Complete Dentures',
      category: 'services',
      title: 'Complete Dentures'
    },
    {
      id: 108,
      src: 'https://readdy.ai/api/search-image?query=Indian%20periodontist%20treating%20gums%20on%20Indian%20patient%2C%20gum%20disease%20treatment%20in%20dental%20clinic%2C%20periodontal%20therapy%20procedure&width=400&height=300&seq=gum-treatments-indian&orientation=landscape',
      alt: 'Gum Treatments',
      category: 'services',
      title: 'Gum Treatments'
    },
    {
      id: 109,
      src: 'https://readdy.ai/api/search-image?query=Indian%20oral%20surgeon%20performing%20dental%20surgery%20on%20Indian%20patient%2C%20oral%20surgery%20procedure%20in%20modern%20dental%20clinic%2C%20surgical%20dentistry&width=400&height=300&seq=oral-surgery-indian&orientation=landscape',
      alt: 'Oral Surgery',
      category: 'services',
      title: 'Oral Surgery'
    },
    {
      id: 110,
      src: 'https://readdy.ai/api/search-image?query=Indian%20dental%20hygienist%20cleaning%20teeth%20of%20Indian%20patient%2C%20professional%20dental%20cleaning%20procedure%2C%20oral%20hygiene%20treatment%20in%20clinic&width=400&height=300&seq=teeth-cleaning-indian&orientation=landscape',
      alt: 'Professional Teeth Cleaning',
      category: 'services',
      title: 'Professional Teeth Cleaning'
    },
    {
      id: 111,
      src: 'https://readdy.ai/api/search-image?query=Indian%20dentist%20placing%20dental%20filling%20on%20Indian%20patient%2C%20composite%20filling%20procedure%20in%20dental%20clinic%2C%20cavity%20restoration%20treatment&width=400&height=300&seq=dental-fillings-indian&orientation=landscape',
      alt: 'Dental Fillings',
      category: 'services',
      title: 'Dental Fillings'
    },
    {
      id: 112,
      src: 'https://readdy.ai/api/search-image?query=Indian%20oral%20surgeon%20extracting%20wisdom%20tooth%20from%20Indian%20patient%2C%20wisdom%20tooth%20removal%20surgery%20in%20dental%20clinic%2C%20oral%20surgery%20procedure&width=400&height=300&seq=wisdom-tooth-indian&orientation=landscape',
      alt: 'Wisdom Tooth Extraction',
      category: 'services',
      title: 'Wisdom Tooth Extraction'
    },
    {
      id: 113,
      src: 'https://readdy.ai/api/search-image?query=Indian%20pediatric%20dentist%20treating%20Indian%20child%20patient%2C%20kid-friendly%20dental%20clinic%2C%20children%20dental%20care%20in%20colorful%20environment&width=400&height=300&seq=pediatric-dentistry-indian&orientation=landscape',
      alt: 'Pediatric Dentistry',
      category: 'services',
      title: 'Pediatric Dentistry'
    },
    {
      id: 114,
      src: 'https://readdy.ai/api/search-image?query=Indian%20orthodontist%20showing%20clear%20aligners%20to%20Indian%20patient%2C%20invisible%20braces%20treatment%2C%20transparent%20orthodontic%20therapy%20in%20dental%20clinic&width=400&height=300&seq=invisible-braces-indian&orientation=landscape',
      alt: 'Invisible Braces',
      category: 'services',
      title: 'Invisible Braces'
    },
    {
      id: 115,
      src: 'https://readdy.ai/api/search-image?query=Indian%20dentist%20providing%20emergency%20dental%20care%20to%20Indian%20patient%2C%20urgent%20dental%20treatment%2C%20emergency%20dentistry%20in%20modern%20clinic&width=400&height=300&seq=emergency-dentistry-indian&orientation=landscape',
      alt: 'Emergency Dentistry',
      category: 'services',
      title: 'Emergency Dentistry'
    },
    {
      id: 116,
      src: 'https://readdy.ai/api/search-image?query=Indian%20cosmetic%20dentist%20performing%20complete%20smile%20makeover%20on%20Indian%20patient%2C%20smile%20transformation%20procedure%2C%20aesthetic%20dentistry%20treatment&width=400&height=300&seq=smile-makeover-indian&orientation=landscape',
      alt: 'Complete Smile Makeover',
      category: 'services',
      title: 'Complete Smile Makeover'
    },
    {
      id: 117,
      src: 'https://readdy.ai/api/search-image?query=Indian%20oral%20surgeon%20performing%20dental%20bone%20grafting%20on%20Indian%20patient%2C%20bone%20regeneration%20procedure%2C%20implant%20preparation%20surgery&width=400&height=300&seq=bone-grafting-indian&orientation=landscape',
      alt: 'Dental Bone Grafting',
      category: 'services',
      title: 'Dental Bone Grafting'
    },
    {
      id: 118,
      src: 'https://readdy.ai/api/search-image?query=Indian%20dentist%20treating%20TMJ%20disorder%20in%20Indian%20patient%2C%20jaw%20joint%20therapy%2C%20temporomandibular%20joint%20treatment%20in%20dental%20clinic&width=400&height=300&seq=tmj-treatment-indian&orientation=landscape',
      alt: 'TMJ Disorder Treatment',
      category: 'services',
      title: 'TMJ Disorder Treatment'
    },
    {
      id: 119,
      src: 'https://readdy.ai/api/search-image?query=Indian%20dentist%20applying%20dental%20sealants%20on%20Indian%20patient%2C%20preventive%20dentistry%20treatment%2C%20tooth%20protection%20procedure%20in%20clinic&width=400&height=300&seq=dental-sealants-indian&orientation=landscape',
      alt: 'Dental Sealants',
      category: 'services',
      title: 'Dental Sealants'
    },
    {
      id: 120,
      src: 'https://readdy.ai/api/search-image?query=Indian%20prosthodontist%20performing%20full%20mouth%20rehabilitation%20on%20Indian%20patient%2C%20complete%20oral%20restoration%2C%20comprehensive%20dental%20treatment&width=400&height=300&seq=full-mouth-rehab-indian&orientation=landscape',
      alt: 'Full Mouth Rehabilitation',
      category: 'services',
      title: 'Full Mouth Rehabilitation'
    }
  ];

  const allImages = [...clinicImages, ...equipmentImages, ...teamImages, ...serviceImages];

  const filteredImages = activeFilter === 'all' 
    ? allImages 
    : allImages.filter(image => image.category === activeFilter);

  const [selectedImage, setSelectedImage] = useState<any>(null);

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Gallery - The Tooth Doctor Advanced Dental Care Centre",
    "description": "View our modern dental facility, meet our expert team, and see the advanced treatments we provide at The Tooth Doctor in Chennai.",
    "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/gallery`,
    "mainEntity": {
      "@type": "ImageGallery",
      "name": "The Tooth Doctor Gallery",
      "description": "Photos of our modern dental clinic, expert team, and advanced dental equipment",
      "about": {
        "@type": "DentalClinic",
        "name": "The Tooth Doctor - Advanced Dental Care Centre"
      }
    },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Gallery",
          "item": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/gallery`
        }
      ]
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Gallery - The Tooth Doctor | Modern Dental Clinic in Chennai"
        description="View our modern dental facility, meet our expert team, and see the advanced treatments we provide at The Tooth Doctor in Chennai."
        keywords="dental clinic gallery, tooth doctor photos, dental facility Chennai, dental equipment, dental team photos"
        canonical={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/gallery`}
        ogTitle="Gallery - The Tooth Doctor Modern Dental Clinic"
        ogDescription="View our modern dental facility, expert team, and advanced treatments at The Tooth Doctor in Chennai."
        ogUrl={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/gallery`}
        ogImage={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/og-gallery.jpg`}
        jsonLd={jsonLd}
      />
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-[#012B53] via-blue-800 to-blue-600 text-white py-20">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Our Gallery
          </h1>
          <p className="text-xl text-blue-100 mb-8 max-w-3xl mx-auto">
            Explore our modern dental facility, meet our expert team, and see the advanced treatments we provide
          </p>
          <nav className="flex justify-center">
            <ol className="flex items-center space-x-2 text-blue-200">
              <li>
                <Link to="/" className="hover:text-white transition-colors">Home</Link>
              </li>
              <li>/</li>
              <li className="text-yellow-300">Gallery</li>
            </ol>
          </nav>
        </div>
      </section>

      {/* Filter Tabs */}
      <section className="py-12 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            {filters.map((filter) => (
              <button
                key={filter.id}
                onClick={() => setActiveFilter(filter.id)}
                className={`px-6 py-3 rounded-full font-medium transition-all duration-300 whitespace-nowrap ${
                  activeFilter === filter.id
                    ? 'bg-[#012B53] text-white shadow-lg'
                    : 'bg-white text-gray-700 hover:bg-blue-50 hover:text-[#012B53] shadow-md'
                }`}
              >
                {filter.name}
              </button>
            ))}
          </div>

          {/* Gallery Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filteredImages.map((image, index) => (
              <div
                key={image.id}
                className={`group relative bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-500 cursor-pointer transform hover:scale-105 hover:border-2 hover:border-[#D4AF37] ${
                  isVisible ? 'animate-fade-in' : 'opacity-0'
                }`}
                style={{ animationDelay: `${index * 0.1}s` }}
                onClick={() => setSelectedImage(image)}
              >
                <div className="aspect-square overflow-hidden">
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.src = `https://readdy.ai/api/search-image?query=Professional%20dental%20clinic%2C%20modern%20dentistry%2C%20dental%20care%20facility%2C%20medical%20equipment&width=400&height=400&seq=fallback-${image.id}&orientation=squarish`;
                    }}
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-4 left-4 right-4 text-white">
                    <h3 className="font-semibold text-lg mb-1">{image.title}</h3>
                    {image.subtitle && (
                      <p className="text-sm text-gray-200">{image.subtitle}</p>
                    )}
                  </div>
                </div>
                <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-10 h-10 bg-[#D4AF37]/20 backdrop-blur-sm rounded-full flex items-center justify-center border border-[#D4AF37]">
                    <i className="ri-eye-line text-[#D4AF37] text-lg"></i>
                  </div>
                </div>
                {/* Service Name Below Image */}
                {image.category === 'services' && (
                  <div className="p-4 bg-white">
                    <h3 className="text-[#012B53] font-bold text-center text-sm">{image.title}</h3>
                  </div>
                )}
              </div>
            ))}
          </div>

          {filteredImages.length === 0 && (
            <div className="text-center py-12">
              <i className="ri-image-line text-6xl text-gray-300 mb-4"></i>
              <p className="text-gray-500 text-lg">No images found for this category</p>
            </div>
          )}
        </div>
      </section>

      {/* Modern Services Gallery Section */}
      {/* Removed dental services section as requested */}

      {/* Statistics Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-team-line text-2xl text-[#012B53]"></i>
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2">15+</div>
              <div className="text-gray-600">Expert Doctors</div>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-service-line text-2xl text-[#D4AF37]"></i>
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2">25+</div>
              <div className="text-gray-600">Services Offered</div>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-smile-line text-2xl text-blue-600"></i>
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2">5000+</div>
              <div className="text-gray-600">Happy Patients</div>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-award-line text-2xl text-green-600"></i>
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2">10+</div>
              <div className="text-gray-600">Years Experience</div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 bg-gradient-to-r from-[#012B53] to-blue-700 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Ready to Experience Our Expert Care?
          </h2>
          <p className="text-xl text-blue-100 mb-8">
            Book your appointment today and join thousands of satisfied patients
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
              className="bg-white text-[#012B53] px-8 py-4 rounded-full font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap"
            >
              Book Appointment
            </button>
            <a
              href="tel:+916369090441"
              className="bg-[#D4AF37] text-white px-8 py-4 rounded-full font-semibold hover:bg-yellow-600 transition-colors whitespace-nowrap"
            >
              Call Now: +91 6369090441
            </a>
          </div>
        </div>
      </section>

      {/* Image Modal */}
      {selectedImage && (
        <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4">
          <div className="relative max-w-4xl max-h-full">
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute -top-12 right-0 text-white hover:text-gray-300 transition-colors"
            >
              <i className="ri-close-line text-3xl"></i>
            </button>
            <img
              src={selectedImage.src}
              alt={selectedImage.alt}
              className="max-w-full max-h-[80vh] object-contain rounded-lg"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.src = `https://readdy.ai/api/search-image?query=Professional%20dental%20clinic%2C%20modern%20dentistry%2C%20dental%20care%20facility%2C%20medical%20equipment&width=800&height=600&seq=modal-fallback-${selectedImage.id}&orientation=landscape`;
              }}
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6 rounded-b-lg">
              <h3 className="text-white text-xl font-semibold mb-2">{selectedImage.title}</h3>
              {selectedImage.subtitle && (
                <p className="text-gray-300">{selectedImage.subtitle}</p>
              )}
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-fade-in {
          animation: fade-in 0.6s ease-out forwards;
        }
      `}</style>
    </div>
  );
}
